<template>
    <li>
        <contacts
            :record="project"
            :editable="can_edit_prospective_data"
            :wizard-shown="wizardShown"
        />
    </li>
</template>

<script type="text/javascript">
import tab from "../mixins/Tab"

import Contacts from "./Contacts"

export default {
    mixins: [tab],
    components: {
        Contacts
    }
}
</script>
